/*import { createContext, useContext, useState } from "react";

type SessionType = {
  sessionNo: number | null;
  setSessionNo: (id: number | null) => void;
};

const SessionContext = createContext<SessionType | undefined>(undefined);

export const SessionProvider = ({ children }: any) => {
  const [sessionNo, setSessionNoState] = useState<number | null>(() => {
    const stored = localStorage.getItem("sessionNo");
    return stored ? Number(stored) : null;
  });

  const setSessionNo = (id: number | null) => {
    setSessionNoState(id);

    if (id !== null) {
      localStorage.setItem("sessionNo", id.toString());
    } else {
      localStorage.removeItem("sessionNo");
    }
  };

  return (
    <SessionContext.Provider value={{ sessionNo, setSessionNo }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used inside SessionProvider");
  }
  return context;
};*/
import { createContext, useContext, useState } from "react";

type SessionType = {
  sessionNo: number | null;
  setSessionNo: (id: number | null) => void;
};

const SessionContext = createContext<SessionType | undefined>(undefined);

export const SessionProvider = ({ children }: any) => {
  // ✅ No localStorage — always fresh session
  const [sessionNo, setSessionNoState] = useState<number | null>(null);

  // ✅ Simple setter
  const setSessionNo = (id: number | null) => {
    setSessionNoState(id);
  };

  return (
    <SessionContext.Provider value={{ sessionNo, setSessionNo }}>
      {children}
    </SessionContext.Provider>
  );
};

export const useSession = () => {
  const context = useContext(SessionContext);
  if (!context) {
    throw new Error("useSession must be used inside SessionProvider");
  }
  return context;
};